import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { PushNotifications, Token } from '@capacitor/push-notifications';
import { Preferences } from '@capacitor/preferences';

const ADMIN_AUTHORITIES = ['ROLE_ADMIN', 'ROLE_MANAGER'];

/** Listeners attach once per app lifecycle; each admin login re-runs {@link PushNotifications.register} to re-bind the token to the current user. */
let listenersAttached = false;

function hasAdminAuthority(authorities?: unknown): boolean {
  if (!Array.isArray(authorities)) return false;
  return authorities.some((authority) => ADMIN_AUTHORITIES.includes(String(authority)));
}

async function sendToken(token: string): Promise<void> {
  const { value: jwt } = await Preferences.get({ key: 'jwt' });
  if (!jwt) return;
  await CapacitorHttp.post({
    url: `${process.env.VUE_APP_API_URL}api/account/admin-push-device`,
    headers: { Authorization: `Bearer ${jwt}`, 'Content-Type': 'application/json' },
    data: { provider: 'FCM', token },
    readTimeout: 15000,
  });
}

async function onRegistration(token: Token): Promise<void> {
  if (!token.value) return;
  await sendToken(token.value);
}

export async function registerAdminPushNotifications(authorities?: unknown): Promise<void> {
  if (!Capacitor.isNativePlatform() || !hasAdminAuthority(authorities)) return;

  if (!listenersAttached) {
    listenersAttached = true;
    await PushNotifications.addListener('registration', onRegistration);
    await PushNotifications.addListener('registrationError', (error) => {
      console.warn('Admin push registration failed', error);
    });
  }

  const permission = await PushNotifications.requestPermissions();
  if (permission.receive !== 'granted') {
    return;
  }
  await PushNotifications.register();
}
